var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2222 79.9245H56.0768L42.6495 56.1869L35.9358 68.0557L35.8159 68.2155L29.2222 79.9245Z",
    fill: "url(#paint0_linear_298_2063)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4606 0L67.4672 12.3483L66.9077 13.3074L59.8344 25.8556L59.3949 26.6149L52.1617 39.3628L51.842 39.9622L44.5289 52.91L42.6507 56.1869L29.2234 79.9245H29.1834L25.1472 72.7313L28.6239 66.6171L28.7438 66.4172L36.1768 53.2697L36.3766 52.91L43.7297 39.9622L44.0494 39.3628L51.2426 26.6149L51.6821 25.8556L58.7954 13.3074L59.3549 12.3483L66.3483 0H74.4606Z",
    fill: "url(#paint1_linear_298_2063)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2737 0L54.2803 12.3483L53.7208 13.3074L46.6076 25.8556L46.168 26.6149L38.9348 39.3628L38.6151 39.9622L31.302 52.91L31.1022 53.2697L23.6293 66.4172L23.5493 66.6171L22.5902 68.2555L18.5141 75.4487L15.9965 79.9245L8.4436 66.6171L8.32371 66.4172L0.890729 53.2697L0.690918 52.91L8.00401 39.9622L8.32371 39.3628L15.5569 26.6149L15.9965 25.8556L23.1097 13.3074L23.6293 12.3483L30.6227 0H61.2737Z",
    fill: "url(#paint2_linear_298_2063)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_2063",
    x1: 35.059,
    y1: 66.5555,
    x2: 48.5403,
    y2: 89.8139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D01D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#C725FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_2063",
    x1: 30.8602,
    y1: 6.61751,
    x2: 66.8041,
    y2: 63.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#430078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#6100DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    stopColor: "#C725FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_2063",
    x1: 9.49864,
    y1: -6.32942,
    x2: 54.4315,
    y2: 65.0965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#430078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#6100DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    stopColor: "#C725FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8dc620d8909375fd9079bc7df2f5821e.svg";
export { ForwardRef as ReactComponent };